import { MouseEvent } from 'react';

export function preventDefault(e: MouseEvent) {
	e.preventDefault();
}
